module.exports = __webpack_public_path__ + "img/offer.e2307c91.jpg";